import React, { useEffect, Suspense } from 'react';

window.openEnquiryPopup = () => window.dispatchEvent(new Event('open-enquiry-popup'));
import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import MerritoPopup from './components/MerritoPopup';
import YoutubePopup from './components/YoutubePopup';
import CustomCodeInjector from './components/CustomCodeInjector';
const Home = React.lazy(() => import('./pages/Home'));
const About = React.lazy(() => import('./pages/About'));
const AboutGroup = React.lazy(() => import('./pages/AboutGroup'));
const PrincipalMessage = React.lazy(() => import('./pages/PrincipalMessage'));
const Admission = React.lazy(() => import('./pages/Admission'));
const Fees = React.lazy(() => import('./pages/Fees'));
const Academics = React.lazy(() => import('./pages/Academics'));
const Curriculum = React.lazy(() => import('./pages/Curriculum'));
const Facilities = React.lazy(() => import('./pages/Facilities'));
const GalleryPage = React.lazy(() => import('./pages/GalleryPage'));
const GalleryDetail = React.lazy(() => import('./pages/GalleryDetail'));
const Events = React.lazy(() => import('./pages/Events'));
const News = React.lazy(() => import('./pages/News'));
const Blog = React.lazy(() => import('./pages/Blog'));
const BlogDetail = React.lazy(() => import('./pages/BlogDetail'));
const Contact = React.lazy(() => import('./pages/Contact'));
const DynamicPage = React.lazy(() => import('./pages/DynamicPage'));
const CoreValues = React.lazy(() => import('./pages/CoreValues'));
const ActivityCalendar = React.lazy(() => import('./pages/ActivityCalendar'));
const Recognition = React.lazy(() => import('./pages/Recognition'));
const AdmissionGuidelines = React.lazy(() => import('./pages/AdmissionGuidelines'));
const InfrastructurePage = React.lazy(() => import('./pages/InfrastructurePage'));
const BeyondClassroomPage = React.lazy(() => import('./pages/BeyondClassroomPage'));
const JobApplication = React.lazy(() => import('./pages/JobApplication'));
const OtherFacilitiesPage = React.lazy(() => import('./pages/OtherFacilitiesPage'));
const OurProgrammesPage = React.lazy(() => import('./pages/OurProgrammesPage'));
const FoundationalProgrammePage = React.lazy(() => import('./pages/FoundationalProgrammePage'));
const ExtraCurricularActivitiesPage = React.lazy(() => import('./pages/ExtraCurricularActivitiesPage'));
const PreparatoryProgrammePage = React.lazy(() => import('./pages/PreparatoryProgrammePage'));
const MiddleSchoolProgrammePage = React.lazy(() => import('./pages/MiddleSchoolProgrammePage'));
const SeniorSchoolProgrammePage = React.lazy(() => import('./pages/SeniorSchoolProgrammePage'));

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  return (
    <>
      <ScrollToTop />
      <Header />
      <CustomCodeInjector />
      <Suspense fallback={<div className="h-screen w-full flex items-center justify-center bg-gray-50"><div className="w-12 h-12 border-4 border-[#0f2444] border-t-transparent rounded-full animate-spin"></div></div>}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/about-group" element={<AboutGroup />} />
        <Route path="/principal-message" element={<PrincipalMessage />} />
        <Route path="/admission" element={<Admission />} />
        <Route path="/fees" element={<Fees />} />
        <Route path="/core-values" element={<CoreValues />} />
        <Route path="/activity-calendar" element={<ActivityCalendar />} />
        <Route path="/recognition" element={<Recognition />} />
        <Route path="/admission-guidelines" element={<AdmissionGuidelines />} />
        <Route path="/infrastructure" element={<InfrastructurePage />} />
        <Route path="/beyond-classroom" element={<BeyondClassroomPage />} />
        <Route path="/other-facilities" element={<OtherFacilitiesPage />} />
        <Route path="/our-programmes" element={<OurProgrammesPage />} />
        <Route path="/foundational-programme" element={<FoundationalProgrammePage />} />
        <Route path="/extra-curricular-activities" element={<ExtraCurricularActivitiesPage />} />
                <Route path="/preparatory-programme" element={<PreparatoryProgrammePage />} />
        <Route path="/middle-school-programme" element={<MiddleSchoolProgrammePage />} />
        <Route path="/senior-school-programme" element={<SeniorSchoolProgrammePage />} />
        {/* WP slug aliases */}
        <Route path="/about-us" element={<About />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/principals-message" element={<PrincipalMessage />} />
        <Route path="/academics" element={<Academics />} />
        <Route path="/curriculum" element={<Curriculum />} />
        <Route path="/facilities" element={<Facilities />} />
        <Route path="/facilities/:slug" element={<Facilities />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/gallery/:slug" element={<GalleryDetail />} />
        <Route path="/events" element={<Events />} />
        <Route path="/news" element={<News />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/article" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
        <Route path="/article/:slug" element={<BlogDetail />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/job-application-form" element={<JobApplication />} />
        <Route path="/:slug" element={<DynamicPage />} />
      </Routes>
      </Suspense>
      <MerritoPopup />
      <YoutubePopup />
      <Footer />
    </>
  );
}

export default App;


